<template>
  <v-card
    outlined
    light
    :class="cardSelected == true ? 'card-selected' : ''"
    class="mb-2 mx-1 elevation-2"
    @click="selectOrder(event)"
  >
    <v-sheet color="blue-grey lighten-5" class="pa-2">
      <span class="text-subtitle-2">{{ infoTopCard.message }}</span>
    </v-sheet>
    <div class="mt-2 pb-1 pl-4 text-subtitle-2">
      <div class="d-flex justify-space-between font-weight-bold">
        <div>
          Pedido S.
          <span class="red--text">#{{ event.order.displayId }} </span>
        </div>
        <v-spacer></v-spacer>
        <div class="mr-4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-on="on" v-bind="attrs" :color="infoTopCard.color">{{
                infoTopCard.icon
              }}</v-icon>
            </template>
            <span v-if="infoTopCard.reasonMessage">
              {{ infoTopCard.reasonMessage }}
            </span>
          </v-tooltip>
        </div>
        <div>
          <v-chip
            v-if="orderExpiration"
            class="red white--text font-weight-bold mr-2"
          >
            {{ orderExpiration }}
          </v-chip>
        </div>
      </div>
      <div class="black--text">
        {{ orderMessage }}
        <div v-if="infoTopCard.warningMessage">
          {{ infoTopCard.warningMessage }}
        </div>
        <span class="font-weight-bold">{{ deliveryDate.substr(0, 5) }}</span>
      </div>
    </div>
    <v-card-text>
      <v-row dense>
        <v-chip small>
          <v-icon left color="red">
            {{ orderType.icon }}
          </v-icon>
          {{ orderType.title }}
        </v-chip>
      </v-row>
      <v-row dense>
        <div class="mt-2">
          <v-chip small class="red white--text">
            via iFood
          </v-chip>
          <v-chip
            class="mr-2"
            v-if="event.order.orderTiming == 'SCHEDULED'"
            small
            outlined
          >
            {{ orderTimingDescription }}
          </v-chip>
          <v-spacer></v-spacer>
        </div>
      </v-row>
    </v-card-text>
    <div class="d-flex flex-row mb-1">
      <v-spacer></v-spacer>
      <div v-for="button in actionButtons" :key="button.id">
        <div
          v-if="
            event.code == button.conditionType &&
              event.code != 'DSP' &&
              !event.isWait &&
              button.visible
          "
        >
          <div v-if="button.orderType.lastIndexOf(event.order.orderType) > 0">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  small
                  :class="button.class"
                  @click="btnAction(button.action, event)"
                >
                  <v-icon>{{ button.icon }}</v-icon>
                </v-btn>
              </template>
              <span>{{ button.title }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { ifoodMixin } from '@/mixins/object/integration/iFood/IfoodMixin'
import { mapState } from 'vuex'

export default {
  name: 'OrderItem',
  mixins: [ifoodMixin],
  props: {
    event: Object,
    startButton: Function,
    cancelButton: Function,
    btnAction: Function,
    id: Number,
  },
  data() {
    return {
      fullscreen: {
        xs: '100vh',
        sm: '64vh',
        md: '62vh',
        lg: '70vh',
        xl: '78vh',
      },
    }
  },
  computed: {
    ...mapState('ifoodModule', ['orderPolling']),

    cardWidth() {
      return this.fullscreen[this.$vuetify.breakpoint.name]
    },
    cardSelected() {
      return (
        this.orderPolling &&
        this.event.order.displayId == this.orderPolling.displayId
      )
    },
    infoTopCard() {
      return this.getInfoTopCard(this.event)
    },
    orderMessage() {
      let message = ''
      switch (this.event.fullCode) {
        case 'PLACED':
          message =
            this.event.order.orderTiming != 'SCHEDULED'
              ? 'Confirmar Pedido'
              : ''
          break
        case 'DISPATCHED':
          message = 'Pedido enviado'
          break
        case 'READY_TO_PICKUP':
          message = 'Pedido Pronto'
          break
        case 'CANCELLED':
          message = `Cancelado pelo ${
            this.event.metadata.CANCEL_ORIGIN == 'RESTAURANT'
              ? 'Restaurante'
              : 'Cliente'
          }`
          break
        case 'CANCELLATION_REQUESTED':
          message = 'Solicitado Cancelamento Restaurante'
          break
        case 'CONSUMER_CANCELLATION_REQUESTED':
          message = 'Solicitado Cancelamento Cliente'
          break
        case 'CONSUMER_CANCELLATION_ACCEPTED':
          message = 'Cancelamento Aceito'
          break
        case 'CONSUMER_CANCELLATION_DENIED':
          message = 'Cancelamento Negado'
          break
        case 'CONFIRMED':
          message = 'Entregue até '
          break
        case 'CONCLUDED':
          message = 'Concluído'
          break
        default:
          message = 'EVENTO NÃO TRATADO'
          break
      }

      return message
    },
    orderTimingDescription() {
      return this.event.order.orderTiming == 'SCHEDULED'
        ? 'Agendado'
        : 'Imediato'
    },
    orderType() {
      let type = this.itemsTipoPrevisaoList.filter(
        (v) => v.value == this.event.order.orderType
      )[0]

      let result = Object.assign({}, type)

      if (this.event.order.delivery) {
        result.title = `${result.title} ${
          this.event.order.delivery.deliveredBy == 'IFOOD'
            ? ' iFood'
            : ' Própria'
        }`
      }
      return result
    },

    deliveryDate() {
      if (this.event.code !== 'CFM') return ''
      const node = this.event.order.takeout ? 'takeout' : 'delivery'
      const dateStart =
        this.event.order.orderTiming !== 'SCHEDULED'
          ? this.event.order[node][`${node}DateTime`]
          : this.event.order.schedule.deliveryDateTimeStart
      return new Date(dateStart).toLocaleTimeString('pt-BR')
    },

    orderExpiration() {
      /**
       *  Limites
       *   Pedidos IMMEDIATE: até 8 minutos após a data do pedido (createdAt)
       *   Pedidos SCHEDULED: até 8 minutos após o horário de início do preparo (preparationStartDateTime)
       *
       *   Pedidos imediatos não tem diferença de data
       *   "createdAt": "2022-07-12T19:59:33.027Z",
       *   "preparationStartDateTime": "2022-07-12T19:59:33.027Z",
       */

      const now = new Date()
      var createdAt = null
      if (this.event.code == 'PLC') {
        createdAt = new Date(this.event.order.preparationStartDateTime)
      } else {
        createdAt = new Date(this.event.createdAt)
      }

      var diferenca = new Date(now - createdAt)

      const resultado = diferenca.getUTCMinutes() + ' min.'
      // resultado += diferenca.getUTCMinutes() + 'm '
      // resultado += diferenca.getUTCSeconds() + 's '

      if (this.event.fullCode == 'PLACED' && !this.event.isWait)
        return resultado
      else return null
    },
  },
  methods: {
    selectOrder(event) {
      this.$emit('selected-order', event)
    },
  },
}
</script>
<style scoped>
.card-selected {
  border: 2px solid red !important;
}
</style>
